import useDocumentTitle from 'utility/hooks/useDocumentTitle';

import PageLayoutSimple, {
	type PageLayoutSimpleProps,
} from './PageLayoutSimple';
import PageLayoutDynamic from './PageLayoutDynamic';

export interface PageLayoutProps extends PageLayoutSimpleProps {
	variant?: 'simple' | 'dynamic';
}

const PageLayout = ({ variant = 'simple', ...rest }: PageLayoutProps) => {
	useDocumentTitle(rest.title);

	if (variant === 'dynamic') {
		return <PageLayoutDynamic {...rest} />;
	}

	return <PageLayoutSimple {...rest} />;
};

export default PageLayout;
